import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=0f781792&scoped=true&"
import script from "./termsAndConditions.vue?vue&type=script&lang=ts&"
export * from "./termsAndConditions.vue?vue&type=script&lang=ts&"
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=0f781792&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f781792",
  null
  
)

export default component.exports